/**
 * A regra de acesso à IA do módulo, em UM lugar.
 *
 * ★ Por que um util e não `hasNoFeatureAccess` repetido em cada view: a flag
 * `IA - Fee Fixo` não protege uma tela, protege uma CAPACIDADE — e ela tem
 * entrada por seis superfícies espalhadas em três telas mais o shell. Enquanto
 * a regra estava escrita numa view só, a varredura seguiu o arquivo e não a
 * capacidade: em 04/08/2026 o owner encontrou o botão "Ensaiar a conversa" da
 * Simulação vivo com a flag desligada, e ao procurar direito eram SEIS
 * superfícies fora do gate, não uma.
 *
 * Com a regra aqui, acrescentar superfície é importar isto; e o teste de
 * invariante (`utils/superficies-de-ia.unit.js`) reprova quem esquecer.
 *
 * Não gateia o BACKEND — lá o gate é `aawz_fee_fixo/core/gate_ia.py`, e é ele
 * quem protege de fato. Isto é a metade de UX: não oferecer caminho que a rota
 * vai recusar.
 */
import { FEATURES } from '@constants/Text'
import { hasNoFeatureAccess } from '@utils/featureAccess'

/**
 * `access` é o `$access` — o computed global que lê `parameters/show`.
 *
 * A negação dupla é do helper do repo (`hasNoFeatureAccess`), e vem dele de
 * propósito: reimplementar a leitura aqui criaria uma segunda regra de
 * permissão para manter em dia.
 */
export function temAcessoIaFeeFixo(access) {
  return !hasNoFeatureAccess(access, FEATURES.IA_FEE_FIXO)
}
